import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1A2332] text-white rounded-t-3xl relative overflow-hidden">
      {/* Watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="text-[#2A3342] text-9xl font-bold opacity-50" style={{ fontFamily: 'Crimson Text, serif' }}>
          AWAKEN
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Column 1 - Brand */}
          <div className="md:col-span-1">
            <h3 className="text-3xl font-bold mb-3" style={{ fontFamily: 'Crimson Text, serif' }}>
              Wake up Church!
            </h3>
            <p className="text-sm text-gray-400 italic mb-4">
              A Call to Spiritual Renewal
            </p>
            <div className="flex justify-start">
              <i className="ri-cross-line text-[#D4AF37] text-2xl"></i>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h4 className="text-base font-semibold mb-4 text-white">Navigate</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  About
                </Link>
              </li>
              <li>
                <Link to="/book" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  Book
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Connect */}
          <div>
            <h4 className="text-base font-semibold mb-4 text-white">Follow Us</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                  Instagram
                </a>
              </li>
              <li>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                  Facebook
                </a>
              </li>
              <li>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  <i className="ri-youtube-fill text-lg"></i>
                  YouTube
                </a>
              </li>
              <li>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line text-lg"></i>
                  Twitter
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - Newsletter */}
          <div>
            <h4 className="text-base font-semibold mb-4 text-white">Stay Inspired</h4>
            <p className="text-sm text-gray-400 mb-4">Weekly devotionals</p>
            <form className="flex gap-2">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 bg-[#2A3342] border border-gray-600 rounded-full px-4 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#D4AF37] transition-colors"
              />
              <button
                type="submit"
                className="w-10 h-10 flex items-center justify-center bg-white text-[#1A2332] rounded-full hover:bg-[#D4AF37] transition-all duration-300 flex-shrink-0 cursor-pointer"
              >
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} Patricia S Welsh. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
